import { mapEnumToOptions } from '@abp/ng.core';

export enum StudentGroup {
  DiningHall = 0,
  Yagyashaala = 1,
  MainHall = 2,
}

export const studentGroupOptions = mapEnumToOptions(StudentGroup);
